import { useEffect, useRef } from 'react';
import { ouvir, type EventoCompilacoes } from '@/lib/eventos';

/** Escuta o barramento de mudanças enquanto o componente está montado. */
export function useEventos(aoReceber: (evento: EventoCompilacoes) => void): void {
  const ref = useRef(aoReceber);
  ref.current = aoReceber;
  useEffect(() => ouvir((evento) => ref.current(evento)), []);
}
